import React from 'react'
import { ReactComponent } from './archive.svg'
import { MergeReactElementProps } from '../types'

interface ArchiveIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', ArchiveIconProps>

export const ArchiveIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill='none' ref={ref} {...props} />
  }
)
